export default __webpack_public_path__ + "static/media/educationalSocietyIcon.81cd9750.png";